module.exports = __webpack_public_path__ + "static/media/Lu_Cisne.a4c9551b.png";